import React from "react";

interface OrganisationTitleProps {
  title: string;
  isHydrated?: boolean;
}

// Deprecated, use OrganisationListElement instead
const OrganisationTitle: React.FC<OrganisationTitleProps> = ({
  title,
  isHydrated = false,
  isLarge = false,
  isShowingLabel = false,
}) => {
  let fontClass = "font-bold";
  let textSize = "text-md";
  let opacityClass = "opacity-80";

  if (isHydrated) {
    fontClass = "font-black";
    opacityClass = "opacity-100";
  }

  if (isLarge) {
    textSize = "text-xl";
  }

  return (
    <div className="flex flex-col text-left">
      {isShowingLabel && (
        <div className="text-xs text-color-dark-text-tertiary">
          Organisation
        </div>
      )}
      <div className="flex flex-row items-center gap-2">
        <h1
          className={`text-left gap-2 ${opacityClass} ${fontClass} ${textSize}`}
        >
          {title}{" "}
          {isHydrated && (
            <span>
              <i className="fas fa-droplet text-xs text-color-raindrop-primary"></i>
            </span>
          )}
        </h1>
      </div>
    </div>
  );
};

export default OrganisationTitle;
